import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "form-header" }, "Confirm phone number", -1)
const _hoisted_3 = { class: "row mt-3" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "mt-3 d-flex justify-content-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("button", { class: "btn-submit w-100" }, "Submit")
  ])
], -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Did not receive the code? ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "need-account-link" }, [
  /*#__PURE__*/_createTextVNode(" Have an issue and need to speak with someone? "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://otcpro.com/support/",
    class: "signup-now-link"
  }, "Contact us")
], -1)
const _hoisted_14 = { class: "need-account-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_modal = _resolveComponent("loading-modal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_recaptcha_block = _resolveComponent("recaptcha-block")!
  const _component_Form = _resolveComponent("Form")!
  const _component_status_block = _resolveComponent("status-block")!
  const _component_login_form_container = _resolveComponent("login-form-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading_modal, { enabled: _ctx.loadingShow }, null, 8, ["enabled"]),
    _createVNode(_component_login_form_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Form, { onSubmit: _ctx.checkSmsCode }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, "SMS with verification code was sent to number " + _toDisplayString(_ctx.user.phone) + ".", 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Field, {
                    type: "text",
                    modelValue: _ctx.smsCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.smsCode) = $event)),
                    name: "code",
                    class: "form-control",
                    placeholder: "Code from SMS",
                    rules: "required|code"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    class: "error-message",
                    name: "code"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editPhone && _ctx.editPhone(...args))),
                    class: "grey-form-link"
                  }, "Edit phone number")
                ])
              ]),
              (_ctx.captchaEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_recaptcha_block, { ref: "recaptcha" }, null, 512)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resendSms && _ctx.resendSms(...args))),
                    class: "signup-now-link"
                  }, "Resend SMS")
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _createVNode(_component_status_block, {
            message: _ctx.errorMessage,
            class: "mt-3"
          }, null, 8, ["message"])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
            class: "signup-now-link"
          }, "Logout")
        ])
      ]),
      _: 1
    })
  ], 64))
}